"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TripHistoryWidgetComponent = /** @class */ (function () {
    function TripHistoryWidgetComponent() {
        this.fullBleed = false;
    }
    return TripHistoryWidgetComponent;
}());
exports.TripHistoryWidgetComponent = TripHistoryWidgetComponent;
